<template>
  <div
    class="createrSays_wrap"
    :style="{ backgroundImage: `url(${moduleIconUrl})` }"
    v-if="!isForPC"
  >
    <div class="header">
      <span
        class="header_title"
        :style="{
          textShadow: `0px 2px 8px ${buttonColor}`,
        }"
        >职场大咖说</span>
      <span
        class="header_desc"
        :style="{ textShadow: `0px 2px 8px ${buttonColor}` }"
        ></span>
    </div>
    <div class="content" v-if="loading">
      <div class="empty">
        <div class="skeleton"></div>
      </div>
    </div>
    <Empty v-else-if="false" text="暂无大咖说" />
    <template v-else>
      <div
        class="content"
      >
        <div
          class="content_creater"
          @click="goCreaterDetail()"
          sensorsname=""
          :sensorsdata="{}"
        >
          <div class="creater_text">{{ componentConfig.activityIntroduction }}</div>
          <div class="creater_info">
            <div class="info_wrap">
              <span class="avatar" :style="{
                backgroundImage: `url('${creatorInfo.avatar}')`,
              }"></span>
              <span class="nickname">{{ creatorInfo.nickName }}</span>
              <span class="split"></span>
              <span class="follows">{{ creatorInfo.followNums || '0' }}&nbsp;粉丝</span>
              <span class="split"></span>
              <span class="zones">{{ creatorInfo.activityNums || '0' }}&nbsp;专区</span>
            </div>
            <van-icon class="arrow" name="arrow" color="rgba(0, 0, 0, 0.5)" size="16" />
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Empty from "../common/EmptyData.vue";
export default {
  name: 'CreaterSays',
  components: {
    Empty,
  },
  props: {
    componentConfig: {
      type: Object,
      default: () => {},
    },
    pageConfig: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      creatorInfo: {}
    }
  },
  computed: {
    ...mapState(["commonStore"]),
    isForPC(){
      return this.commonStore.isForPC
    },
    backgroundConfigDTO(){
      return this.componentConfig.backgroundConfigDTO
    },
    buttonColor(){
      return this.backgroundConfigDTO?.buttonColor||this.pageConfig.buttonColor
    },
    moduleIconUrl(){
      if(this.commonStore.isForPC){
        return this.backgroundConfigDTO?.moduleIconPcUrl||this.pageConfig.moduleIconPcUrl
      }else{
        return this.backgroundConfigDTO?.moduleIconUrl||this.pageConfig.moduleIconUrl
      }
    }
  },
  mounted() {
    this.initCreaterSays();
  },
  methods: {
    initCreaterSays() {
      const params = {
        creatorId: this.componentConfig.activityCreatorId,
      };
      this.$api.activity.activityCreatorInfo(params).then((res) => {
        if (res.code == 0 && Object.keys(res.data).length !== 0) {
          this.creatorInfo = res.data,
          this.$store.commit("setValueLocalStorage", {
            creatorInfo: this.creatorInfo,
          });
        }
      })
      
    },
    goCreaterDetail() {
      this.$sensors.track("$WebClick", {
        $element_id: "sensor_bcop_kochome",
        groupId: this.componentConfig.activityCreatorId,
      });
      // const q = this.$route.query;
      this.$router.push({
        name: "CreaterHome",
        query: {
          creatorid: this.componentConfig.activityCreatorId,
        }
      });
    }
  }
}
</script>

<style lang="less" scoped>
.createrSays_wrap {
  width: 100%;
  box-sizing: border-box;
  border-radius: 12px 12px 0px 0px;
  overflow: hidden;
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 100% auto;
  padding-bottom: 24px;
  position: relative;
  .adapt_pc_widescreen & {
    width: 1200px;
    margin: 0 auto;
  }
  .header {
    display: flex;
    align-items: baseline;
    padding: 13px 16px 10px 16px;
    font-weight: 600;

    .header_title {
      // font-family: HarmonyOS_Sans_SC_Bold;
      font-size: 20px;
      color: #FFFFFF;
      line-height: 30px;
    }
    .header_desc {
      // font-family: HarmonyOS_Sans_SC_Medium;
      font-size: 14px;
      color: #FFFFFF;
      line-height: 19px;
      margin-left: 9px;
      font-weight: 500;
    }
  }

  .content {
    background: #FFFFFF;
    border-radius: 8px;
    margin: 8px;
    margin-top: 0px;
    overflow: hidden;
    .empty {
      width: 100%;
      height: 118px;
      border-radius: 8px;
      box-sizing: border-box;
      position: relative;
      border: 1px solid #ffffff;
      cursor: pointer;
      background-image: url("@/assets/img/activity/empty_company@3x.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .skeleton {
      width: 100%;
      height: 100%;
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0) 24%,
        rgba(255, 255, 255, 0.9) 25%,
        rgba(255, 255, 255, 0.9) 75%,
        rgba(255, 255, 255, 0) 76%,
        rgba(255, 255, 255, 0) 100%
      );
      background-size: 50% 100%;
      filter: blur(25px);
      animation: gradient 1.5s linear infinite;
    }

    @keyframes gradient {
      0% {
        background-position: 0% 50%;
      }

      100% {
        background-position: 100% 50%;
      }
    }

    
    .content_creater {
      padding: 10px 12px 8px 12px;

      .creater_text {
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        max-height: 66px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        white-space: normal;
        text-overflow: ellipsis;
      }

      .creater_info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 48px;
        border-radius: 6px;
        background: #F8F8F8;
        margin: 8px 0 0;
        padding: 9px 12px;

        .info_wrap {
          flex: 1;
          display: flex;
          justify-content: flex-start;
          align-items: center;

          .avatar {
            flex-grow: 0;
            display: block;
            width: 30px;
            height: 30px;
            content: '';
            border-radius: 15px;
            opacity: 1;
            box-sizing: border-box;
            border: 1px solid rgba(0, 0, 0, 0.25);
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
          }

          .nickname {
            flex-shrink: 1;
            flex-grow: 0;
            display: block;
            padding-left: 8px;
            max-width: 130px;
            overflow: hidden;
            font-size: 12px;
            font-weight: 600;
            line-height: 20px;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          
          .follows, .zones {
            flex-grow: 0;
            display: block;
            font-size: 11px;
            font-weight: normal;
            line-height: 20px;
          }

          .split {
            flex-grow: 0;
            display: block;
            content: '';
            flex: 0;
            width: 1px;
            height: 10px;
            border-left: 1px solid #D8D8D8;
            margin: 0 8px;
          }
        }
        .arrow {
          display: block;
          flex: 0;
        }
      }
    }
  }
}
</style>